<template>
  <v-app
    :style="
      isPublicDisplay
        ? 'background: rgba(0,0,0,0) !important;'
        : $vuetify.theme.dark
        ? 'bgDark'
        : 'bgLight'
    "
  >
    <AppBar v-if="isAuthenticated && !isChromeless" />
    <v-divider
      style="color: white"
      v-if="!isPublicDisplay && !isGloboGraphics"
    ></v-divider>

    <v-main>
      <v-container fluid class="pa-0">
        <v-tabs
          background-color="primary"
          grow
          active-class="subtitle-1 font-weight-bold"
          center-active
          v-if="isAuthenticated && !isChromeless && !isRootLevel"
        >
          <v-tab to="/producoes"> Produções</v-tab>
          <v-tab to="/usuarios"> Usuários</v-tab>
          <v-tab to="/aprovadores"> Aprovadores </v-tab>
          <v-tab to="/enquetes-categorias">Enquetes</v-tab>
          <v-tab to="/cameras">Câmeras</v-tab>
          <v-tab to="/log"> Log </v-tab>
        </v-tabs>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar/AppBar.vue";
import "@/styles/global.scss";
import "@/styles/fonts.scss";
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: { AppBar },
  beforeCreate() {
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
    const localStorageDarkThemeValue = localStorage.getItem("@socialcam/is_dark_theme");
    if (localStorageDarkThemeValue !== null) {
      const isDarkTheme = localStorageDarkThemeValue === "true" ? true : false;
      if (isDarkTheme) {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else {
      this.$vuetify.theme.dark = true;
      localStorage.setItem("@socialcam/is_dark_theme", true);
    }
  },
  async created() {
    await this.$store.dispatch("producoes/initFromStorage");
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "users/isAuthenticated",
    }),
    // Every route test below reads $route, not $router.currentRoute: only the
    // former is reactive, so with currentRoute an in-app push left the chrome
    // showing whatever the last full page load had resolved.

    // Token-authenticated screens rendered on air — no app chrome, transparent
    // page background so the broadcast key shows through.
    isPublicDisplay() {
      return ["tarja", "mosaico", "mosaico-cameras", "enquete", "cena"].includes(this.$route.name);
    },
    // Globo Graphics brings its own header and palette.
    isGloboGraphics() {
      return ["globographics", "globographics-configuracoes"].includes(this.$route.name);
    },
    // Everything that owns its full viewport: no SocialCam app bar, no admin tabs.
    isChromeless() {
      return this.isPublicDisplay || this.isGloboGraphics || ["gnews", "noticias"].includes(this.$route.name);
    },
    // The admin tab bar is the nav *into* the config section, so it stays off the
    // screens that section is entered from.
    isRootLevel() {
      return ["moderacao", "login"].includes(this.$route.name);
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Globotipo";
  src: url("@/assets/Globotipo_Regular.otf") format("opentype");
}

.v-tab {
  text-transform: none !important;
  color: var(--v-common_text-base) !important;
}

.v-btn::before {
  display: none;
}

p,
span,
label {
  color: var(--v-text_secondary-base);
}
.v-application {
  font-family: "Globotipo", sans-serif !important;
}

.v-application .subtitle-1 {
  font-family: "Globotipo", sans-serif !important;
}

.theme--light.v-application {
  background: var(--v-surface_tertiary-base) !important;
}

.theme--dark.v-application {
  background: var(--v-surface_secondary-base) !important;
}

.theme--dark.v-input__icon--prepend-inner .v-icon {
  color: var(--v-text_secondary-base) !important;
}

.theme--light.v-input__icon--prepend-inner .v-icon {
  color: var(--v-icon_selected-base) !important;
}

.theme--dark.v-text-field input::placeholder {
  color: var(--v-text_secondary-base) !important;
}

.theme--light.v-text-field input::placeholder {
  color: var(--v-surface_selected-base) !important;
}

.v-data-footer {
  background: var(--v-table_data_bg-base);
}
th {
  color: var(--v-table_header_text-base) !important;
  width: 385px !important;
  height: 72px !important;
}
td {
  // width: 353px !important;
  min-height: 64px;
  font-weight: 400;
  color: var(--v-text_primary-base) !important;
}

div.v-input__icon.v-input__icon--prepend button {
  border-radius: var(--sc-radius-sm);
  background: var(--v-primary-base) !important;
  color: white;
  width: 20px;
  height: 20px;
}

.theme--light.v-card {
  background: var(--v-surface_tertiary-base) !important;
}
.v-toolbar__content:not(:has(.toolbarAppBar)) {
  background: var(--v-surface_tertiary-base) !important;
  box-sizing: content-box;
}

.v-toolbar__title {
  font-weight: 700;
  color: var(--v-text_primary-base);
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}

.v-btn--is-elevated {
  box-shadow: none !important;
}

.v-application--is-ltr .v-input__prepend-outer {
  margin-right: 0 !important;
}

div.v-dialog.v-dialog--active {
  box-shadow: none !important;
}
</style>
